import * as React from 'react';
import type { SVGProps } from 'react';

const SvgHamburgerIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={30} height={21} fill="none" {...props}>
    <path stroke="#000000" d="M0 .5h30M0 10.5h30M0 20.5h30" />
  </svg>
);
export default SvgHamburgerIcon;
